export const scrollToBottom = (footerRef) => {
    footerRef.current?.scrollIntoView({behavior: "smooth"})
}